import { BackIcon } from '@icons'

import './backButton.scss'

type BackButtonProps = {
  caption?: string
  onClick: () => void
}

const BackButton = ({ caption, onClick }: BackButtonProps) => (
  <div className='back-button-wrapper' onClick={onClick} data-test='back-button'>
    <BackIcon />
    {caption ? <span>{caption}</span> : null}
  </div>
)

export default BackButton
